// store/modules/loading.js
const state = {
  isLoading: false,
}

const mutations = {
  setLoading(state, status) {
    state.isLoading = status;
  },
}

const actions = {
  showLoading({ commit }) {
    commit('setLoading', true);
  },
  hideLoading({ commit }) {
    commit('setLoading', false);
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
}
